/* Product description — clips long descriptions on mobile behind a "Read more" toggle
   (snippets/product-description.liquid). Only collapses when the text is meaningfully
   taller than the collapsed height, so short descriptions never get a pointless button. */
if (!customElements.get('product-description')) {
  class ProductDescription extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector('.product-desc__body');
      this.toggle = this.querySelector('.product-desc__toggle');
      if (!this.body || !this.toggle) return;

      this.mq = window.matchMedia('(max-width: 768px)');
      this.update = this.update.bind(this);
      this.toggle.addEventListener('click', this.onToggle.bind(this));
      this.mq.addEventListener('change', this.update);
      // Images or fonts inside the description can change its height after load
      this.ro = new ResizeObserver(() => this.update());
      this.ro.observe(this.body);
      this.update();
    }

    disconnectedCallback() {
      if (this.mq) this.mq.removeEventListener('change', this.update);
      if (this.ro) this.ro.disconnect();
    }

    collapsedHeight() {
      return parseFloat(getComputedStyle(this).getPropertyValue('--desc-collapsed')) || 220;
    }

    update() {
      if (this.classList.contains('is-open')) {
        this.style.setProperty('--desc-open-height', this.body.scrollHeight + 'px');
        return;
      }
      // Leave ~3 extra lines of slack so we never hide just one or two lines
      const collapsible = this.mq.matches && this.body.scrollHeight > this.collapsedHeight() + 72;
      this.classList.toggle('is-collapsible', collapsible);
      this.toggle.hidden = !collapsible;
    }

    onToggle() {
      const open = !this.classList.contains('is-open');
      this.style.setProperty('--desc-open-height', this.body.scrollHeight + 'px');
      this.classList.toggle('is-open', open);
      this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

      // When collapsing a long description, bring its start back into view
      if (!open) {
        const top = this.getBoundingClientRect().top;
        if (top < 0) window.scrollBy({ top: top - 100, behavior: 'smooth' });
      }
    }
  }

  customElements.define('product-description', ProductDescription);
}
